import { memo } from 'react';

import styles from './SearchKnmPanelFilters.module.scss';

interface IKnmSearchFilterStringProps {
  filterName: string;
  filterValue: string;
  removeFilterValue: () => void;
}

export const KnmSearchFilterString = memo(
  ({ filterName, filterValue, removeFilterValue }: IKnmSearchFilterStringProps) => (
    <div className={styles.FilterWrap}>
      <div className={styles.FilterLabel}>{filterName}</div>
      <div className={styles.FilterWrap}>
        <div className={styles.FilterTextWrap}>
          <div className={styles.FilterText}>{filterValue}</div>
          <div className={styles.FilterRemove} onClick={removeFilterValue} />
        </div>
      </div>
    </div>
  ),
);
